var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"container-fluid"},[_c('h1',{staticClass:"main-title"},[_vm._v(_vm._s(_vm.title))]),_c('downtime-category-wizard',{attrs:{"initial-category":_vm.category,"initial-parent-category":_vm.parentCategory,"all-categories":_vm.allCategories,"category-by-id":_vm.categoryById}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }